import { cn } from '@/lib/utils';

import { Text } from '@/decodo/components/atoms/Text';

type MenuListWrapperProps = {
  title: string;
  children: React.ReactNode;
  hideTitleOnMobile?: boolean;
  classNames?: {
    root?: string;
    title?: string;
  };
};

export function MenuListWrapper({
  title,
  children,
  hideTitleOnMobile = false,
  classNames,
}: MenuListWrapperProps) {
  return (
    <div
      className={cn(
        'headerLg:w-auto relative z-[1] flex size-full flex-col',
        classNames?.root
      )}
    >
      {!!title?.trim() && (
        <Text
          variant='label-medium'
          color='gray-dark-500'
          classNames={{
            wrapper: cn(
              'uppercase select-none font-serif px-2 mb-6 headerLg:block shrink-0',
              classNames?.title,
              hideTitleOnMobile && 'hidden headerLg:block'
            ),
          }}
        >
          {title}
        </Text>
      )}
      {children}
    </div>
  );
}
